<template>
  <div id="app">
    <!-- <h1>GAP Formular</h1> -->

    <div class="container">


      <div class="programm" id="programm">

        <div class="container-fluid">
          <div class="row">
            <div class="mb-5 mb-md-0 col-md-4 col-12">
              <div class="stepName">{{ activeStep.name }}</div>
              <div class="steps">
                <div class="step" v-for="step in steps" v-bind:key="step.id" :class="{ active: step.active, finish: step.finish }"><a href="" @click="goToStep(step.id)" v-if="formData.currentStep > step.id && step.id > 0 && formData.currentStep < 5">{{ step.name }}</a> <span v-else>{{ step.name }}</span> <i class="rounded-circle" :class="{ shadow: step.active }"></i></div>
              </div>
            </div>

            <div class="col-md-8 col-12 text-left pl-md-5 pb-5">

              <div class="formContainer">
                <div class="packet" v-if="formData.currentStep < 5 && this.errorServer === 0">

                  <div v-if="formData.currentStep === 0" class="packet-title">
                    <span class="name">Bitte wähle Dein Paket</span>
                  </div>
                  <div v-if="formData.currentStep !== 0" class="packet-title">
                    <span class="name">{{ activeProgramm.name }}</span>
                    <span class="formInfos" :class="{ active: activeProgramm.showMe }"  @click="activeProgramm.showMe = !activeProgramm.showMe"><i class="rounded-circle">i</i><span class="infos--content p-4 shadow bg-white position-absolute">TEST1 {{ activeProgramm.info }}</span></span>
                    <div class="change"  @click="openPackages">Paket wechseln</div>
                  </div>

                  <div class="content p-4 shadow bg-white position-absolute" v-bind:class="{ active: showPackages, invisible: !showPackages}">

                    <i class="close" @click="openPackages">X</i>


                    <div class="row">

                      <div class="item pb-5 pb-lg-2 col-12 col-lg-6" v-for="prog in programms" v-bind:key="prog.id">
                        <div class="title">{{ prog.name }}</div>
                        <div class="description">{{ prog.description }}</div>
                        <div class="usps">
                          <ul>
                            <li v-for="usp in prog.usps" v-bind:key="usp.name" >{{ usp }}</li>
                          </ul>
                        </div>
                        <div class="price"><span class="price">{{ texte.currency }}{{ prog.price }}</span><span class="price-tax">{{ texte.tax }}</span></div>

                        <div class="change btn btn-primary color-white rounded-pill" @click="changePackages( prog.id )">TEST 2Paket auswählen</div>
                      </div>
                    </div>


                  </div>
                </div>

                <div class="usps" v-if="formData.currentStep < 5 && formData.currentStep > 0 && this.errorServer === 0">
                  <ul>
                    <li v-for="usp in activeProgramm.usps" v-bind:key="usp.name">{{ usp }}</li>
                  </ul>
                </div>

                <div class="formEdit"  v-if="this.errorServer === 0">
                  <a class="d-block" href="" v-if="formData.currentStep  > 1 && formData.currentStep < 5" @click="goToStep(1)" >Edit<span class="name"> {{ steps[1].name }}</span></a>
                  <a class="d-block" href="" v-if="formData.currentStep  > 2 && formData.currentStep < 5" @click="goToStep(2)" >Edit<span class="name"> {{ steps[2].name }}</span></a>
                  <a class="d-block" href="" v-if="formData.currentStep  > 3 && formData.currentStep < 5" @click="goToStep(3)" >Edit<span class="name"> {{ steps[3].name }}</span></a>
                </div>

                <ValidationObserver v-slot="{ handleSubmit }">
                  <form @submit.prevent="handleSubmit(onSubmit)">

                <ValidationObserver v-if="formData.currentStep === 0">
                  <div class="row">

                    <div class="item pb-5 pb-lg-2 col-12 col-lg-6" v-for="prog in programms" v-bind:key="prog.id">
                      <div class="title" style="margin-bottom: 10px;">{{ prog.name }}</div>
                      <div class="description">{{ prog.description }}</div>
                      <div style="min-height: 80px;" class="usps">
                        <ul>
                          <li style="text-indent: -16px;" v-for="usp in prog.usps" v-bind:key="usp.name" >{{ usp }}</li>
                        </ul>
                      </div>
                      <div class="price"><span style="font-size: 1.25rem; font-weight: bold;" class="price">{{ prog.price }} {{ texte.currency }} </span><br><span style="font-size: 0.95rem">Preis für 6 Monate (optional verlängerbar)</span><br><span style="font-size: 0.7rem;" class="price-tax">{{ texte.tax }}</span></div>

                      <div style="line-height: 40px; margin-top: 20px;" class="change btn btn-primary color-white rounded-pill" @click="selectPackage(prog.id)">Paket auswählen</div>
                    </div>
                  </div>
                </ValidationObserver>

                    <ValidationObserver v-if="formData.currentStep === 1">

                      <!-- Step 1 -->
                      <!-- Gender -->
                      <ValidationProvider class="form-item d-block" name="gender" rules="required" v-slot="{ errors }">
                            <span class="radio-options">
                              <span class='radio'>
                                <label class='radio-container'>
                                  Frau
                                  <input type='radio' value='Frau' name='gender' id='women' v-model='formData.gender' />
                                  <span class='checkmark'></span>
                                </label>
                              </span>
                              <span class='radio'>
                                <label class='radio-container'>
                                  Herr
                                  <input type='radio' value='Herr' name='gender' id='men' v-model='formData.gender' />
                                  <span class='checkmark'></span>
                                </label>
                              </span>
                            </span>
                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>
                      <!-- EOF: Gender -->

                      <!-- Vorname -->
                      <ValidationProvider class="form-item d-block" name="firstname" rules="required|alpha_spaces" v-slot="{ errors }">
                        <label for="firstname">{{ formLabels.firstname }}</label>
                        <input v-model="formData.firstname" id="firstname" name="firstname" type="text" />
                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>
                      <!-- EOF: Vorname -->

                      <!-- Nachname -->
                      <ValidationProvider class="form-item d-block" name="lastname" rules="required|alpha_spaces" v-slot="{ errors }">
                        <label for="lastname">{{ formLabels.lastname }}</label>
                        <input v-model="formData.lastname" id="lastname" name="lastname" type="text" />
                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>
                      <!-- EOF: Nachname -->

                      <!-- Telefone -->
                      <ValidationProvider class="form-item d-block" name="phone" rules="required" v-slot="{ errors }">
                        <label for="phone">{{ formLabels.phone }}</label>
                        <input v-model="formData.phone" id="phone" name="phone" type="text" />
                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>
                      <!-- EOF: Telefone -->

                      <!-- Email -->
                      <ValidationProvider class="form-item d-block" name="Email" rules="email|required" v-slot="{ errors }">
                        <label for="email">{{ formLabels.mail }}</label>
                        <input v-model="formData.mail" id="email" type="text" placeholder="">
                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>
                      <!-- EOF: Email -->

                      <!-- Birhtday -->
                      <ValidationProvider class="form-item d-block" name="birthday" :rules="{ required: true, regex: /^([0-9]{4}[-/.]?((0[13-9]|1[012])[-/.]?(0[1-9]|[12][0-9]|30)|(0[13578]|1[02])[-/.]?31|02[-/.]?(0[1-9]|1[0-9]|2[0-8]))|([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048])00)[-/.]?02[-/.]?29)$|(0[1-9]|1\d|2\d|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d{2}$/ }" v-slot="{ errors }">
                        <label for="birthday">{{ formLabels.birthday }}</label>
                        <input v-model="formData.birthday" id="birthday" name="birthday" type="text" placeholder="dd.mm.yyyy" />
                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>
                      <!-- EOF: Birhtday -->
                      <!-- EOF: Step 1 -->

                    </ValidationObserver>

                    <ValidationObserver v-else-if="formData.currentStep === 2">

                      <!-- Kommunikation -->
                      <ValidationProvider class="form-item d-block switch-toggle" name="communication" rules="required" v-slot="{ errors }">

                        <span class="label">{{ formLabels.communication }}</span>

                        <span>
                            <span class="switch-item" v-for="val in communication" v-bind:key="val.value">
                                <input type='radio' :value='val.value' :name='val.name' :id='val.id' v-model='formData.communication' />
                               <label :for="val.id">{{ val.label }}</label>
                          </span>
                        </span>

                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>
                      <!-- EOF: Kommunikation -->

                      <!-- Diagnostik -->
                      <ValidationProvider class="form-item d-block switch-toggle" name="diagnosis" rules="required" v-slot="{ errors }">

                        <span class="label">{{ formLabels.diagnosis }}
                            <i class="ml-3 rounded-circle-icon" @click="texte.infoDiagnosis.showMe = !texte.infoDiagnosis.showMe">i</i>
                            <span class="formInfos" :class="{ active: texte.infoDiagnosis.showMe }"  >
                            <span class="infos--content p-4 shadow bg-white position-absolute">{{ texte.infoDiagnosis.diagnosis }}</span>
                            </span>
                            </span>

                        <span>
                          <span>
                           <span class="switch-item" v-for="val in diagnosis" v-bind:key="val.value">
                                <input type='radio' :value='val.value' :name='val.name' :id='val.id' v-model='formData.diagnosis' />
                               <label :for="val.id">{{ val.label }}</label>
                          </span>
                        </span>



                        </span>

                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>
                      <!-- EOF: Diagnostik -->


                      <!-- Regional -->


                      <div id="regional" class="form-item d-block switch-toggle">

                        <span class="label">{{ formLabels.regional }}</span>

                        <span>
                           <span class="switch-item" v-for="val in regional" v-bind:key="val.value">
                             <input v-on:change="changeRegio" type='checkbox' :value='val.value' :name='val.name+val.key' :id='val.id' v-model='val.set'  />
                               <label :for="val.id">{{ val.label }}</label>
                          </span>
                        </span>

                      </div>

                      <ValidationProvider id="regionalHidden" class="form-item d-block switch-toggle" name="regionalTest" rules="required" v-slot="{ errors }">

                        <span>
                           <span class="switch-item">
                             <input type='radio' value='regio' name='regionalTest' v-model='formData.regional'  />
                          </span>
                        </span>

                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>
                      <!-- EOF: Regional -->


                      <!-- Interesse -->
                      <ValidationProvider class="form-item d-block multiselection" name="interest" rules="required" v-slot="{ errors }">

                        <span class="label">{{ formLabels.interest }}</span>

                        <div class="selectionFrame">
                          <multiselect v-model="formData.interest" @input="onChange" select-label="Klicken um hinzuzufügen" deselect-label="Klicken um zu entfernen" :options="interest" :multiple="true" :close-on-select="false" :clear-on-select="false" :allow-empty="true" :clearAllButton="true" placeholder="Auswählen" label="name" track-by="name">
                          </multiselect>
                          <span class="countMulti" v-if="formData.interest">{{ formData.interest.length }}</span>
                          <span class="clearAll" @click="clearAll()">X</span>
                          <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                        </div>

                      </ValidationProvider>
                      <!-- EOF: Interesse -->

                      <!-- Email -->
                      <ValidationProvider class="form-item d-block" name="Intressen" v-slot="{ errors }">
                        <label for="email">{{ formLabels.interest_text }}</label>
                        <input v-model="formData.interest_text" id="interessen" type="text" placeholder="">
                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>
                      <!-- EOF: Email -->


                    </ValidationObserver>

                    <ValidationObserver v-else-if="formData.currentStep === 3">

                      <ValidationProvider class="form-item d-block" rules="required" v-slot="{ errors }">
                        <label>{{ formLabels.documents }}</label>
                        <vue2Dropzone ref="resume" id="resume" :options="resumeOptions" :destroyDropzone="false" :useCustomSlot="true" @vdropzone-removed-file="afterResumeRemove" @vdropzone-complete="afterResumeComplete">
                          <div class="dropzone-custom-content">
                            <h3 class="dropzone-custom-title">Lebenslauf</h3>
                            <div class="subtitle">...Drag and Drop oder Klicken um den Lebenslauf hochzuladen.</div>
                            <i class="icon"><img src="./assets/upload.png" alt="Upload" /></i>
                          </div>
                        </vue2Dropzone>

                        <input type="hidden" name="resume_name" id="resume_name" v-model='formData.resume_name'>
                        <input type="hidden" name="resume_size" id="resume_size" v-model='formData.resume_size'>
                        <input type="hidden" name="resume_type" id="resume_type" v-model="formData.resume_type">

                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>

                      <ValidationProvider class="form-item d-block" rules="required" v-slot="{ errors }">
                        <vue2Dropzone ref="picture" id="picture" :options="pictureOptions" :destroyDropzone="false" :useCustomSlot="true" @vdropzone-removed-file="afterPictureRemove" @vdropzone-complete="afterPictureComplete">
                          <div class="dropzone-custom-content">
                            <h3 class="dropzone-custom-title">Zeugnisse / Dokumente</h3>
                            <div class="subtitle">...Drag and Drop oder Klicken um dein Zeugnis und/oder sonstige Dokumente hochzuladen.</div>
                            <i class="icon"><img src="./assets/upload.png" alt="Upload" /></i>
                          </div>
                        </vue2Dropzone>

                        <input type="hidden" name="picture_name" id="picture_name" v-model='formData.picture_name'>
                        <input type="hidden" name="picture_size" id="picture_size" v-model='formData.picture_size'>
                        <input type="hidden" name="picture_type" id="picture_type" v-model="formData.picture_type">

                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>


                      <ValidationProvider class="form-item d-block" rules="required" v-slot="{ errors }">
                        <vue2Dropzone ref="testimony" id="testimony" :options="testimonyOptions" :destroyDropzone="false" :useCustomSlot="true" @vdropzone-removed-file="afterTestimonyRemove" @vdropzone-complete="afterTestimonyComplete">
                          <div class="dropzone-custom-content">
                            <h3 class="dropzone-custom-title">Bild</h3>
                            <div class="subtitle">...Drag and Drop oder Klicken um den Lebenslauf hochzuladen.</div>
                            <i class="icon"><img src="./assets/upload.png" alt="Upload" /></i>
                          </div>
                        </vue2Dropzone>

                        <input type="hidden" name="testimony_name" id="testimony_name" v-model='formData.testimony_name'>
                        <input type="hidden" name="testimony_size" id="testimony_size" v-model='formData.testimony_size'>
                        <input type="hidden" name="testimony_type" id="testimony_type" v-model="formData.testimony_type">

                        <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                      </ValidationProvider>

                      <notice>{{ texte.infoDocuments }}</notice>

                    </ValidationObserver>

                    <ValidationObserver v-else-if="formData.currentStep === 4">

                      <div class="content" v-if="errorServer ===1">
                        <h3>Leider konnten deine Daten nicht übermittelt werden.</h3>
                        <h1>Problem bei der Verbindung!</h1>
                        <p>Woran kann dies liegen?</p>
                        <ul>
                          <li> Du hattest keine Internetverbindung.</li>
                          <li> Auf unserem Server lag ein Problem vor.</li>
                          <li> ...</li>
                        </ul>
                        <p>Versuch uns einfach nochmal deine Daten zu senden.</p>
                      </div>

                      <div class="content" v-if="errorServer ===0">
                        <div class="pricing">
                          <h3>Folgende kosten werden Dir in Rechnungen gestellt</h3>
                          <div class="packet">
                            <div class="item">
                              <span class="label">{{ activeProgramm.name }} : {{ activeProgramm.month }}</span>
                              <span class="price">{{ texte.currency }}{{ activeProgramm.price }}</span>
                            </div>

                            <div class="item" v-for="option in activeProgramm.options" v-bind:key="option.id">
                              <label class="checkContainer">{{ option.name }}
                                <input type="checkbox" v-on:change="changeProgrammOptions" :value="option.id"  :name="option.inputname" v-model="option.checked">
                                <span class="checkmark"></span>
                              </label>

                              <span class="price" v-if="option.price > 0">+ {{ texte.currency }}{{ option.price }}</span><span class="price" v-else>kostenlos</span>
                            </div>
                          </div>

                          <div class="priceSum">
                            <div class="label">Summe</div>
                            <div class="price">{{ formData.price }} {{ texte.currency }} ({{ formData.monthlyprice }} {{ texte.currency }} monatlich)</div>
                            <div class="tax">{{ texte.tax }}</div>
                          </div>
                        </div>
                      </div>

                    </ValidationObserver>


                    <button type="submit" class="btn-primary" v-if="formData.currentStep < 4 && formData.currentStep > 0">Weiter</button>

                    <!-- AGB -->
                    <ValidationProvider class="form-item d-block agbs" name="agb" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }" v-if="formData.currentStep === 4">
                      <label for="agb" class="checkContainer">Ich Stimme den <a href="agb" target="_blank">AGB</a> und <a href="datenschutz" target="_blank">Datenschutzbestimmungen</a> zu.
                        <input type="checkbox" id="agb"  name="agb" v-model="formData.agb">
                        <span class="checkmark"></span>
                      </label>
                      <span class="error text-danger d-block mt-1"><small>{{ errors[0] }}</small></span>
                    </ValidationProvider>
                    <!-- EOF: AGB -->

                    <button type="submit" class="btn-primary call-to-action" v-if="formData.currentStep === 4">Verbindlich anmelden</button>


                    <notice v-if="formData.currentStep === 4">Nach verbindlcher Anmeldung erhälst Du von uns eine E-Mail-Bestätigung mit der Rechnung. Diese Rechnung muss innerhalb von 14 Tagen überwiesen werden.</notice>

                    <!-- @todo ausdokumentieren, soll später eingesetzt werden. -->
                    <!-- <div class="skipStep" v-if="formData.currentStep === 3">
                      <label>Unterlagen nicht zur Hand?</label>
                      <button class="btn-primary">Überspringen und später hochladen</button>
                    </div> -->


                    <!-- Bestätigungsseite -->
                    <div class="finishStep" v-if="formData.currentStep === 5">
                      <div class="container">
                        <div class="row">
                          <div class="col-2"><i v-bind:class="{ 'icon-error': errorServer, 'icon-check': !errorServer}"></i></div>
                          <div class="col-10">
                            <!-- @todo Texte setzen. Die Icons bei den Links setzen und die Links richtig verlinken. -->
                            <div class="content">
                              <h3>Vielen Dank für Deine Anmeldung</h3>
                              <h1>Willkommen bei GapYear Praxis!</h1>
                              <p>Wie geht's weiter?</p>
                              <ul>
                                <li> Du bekommt eine Bestätigungsemail zur Anmeldung um deine E-Mail Adresse zu überprüfen.</li>
                                <li> Wir sichten deine Unterlagen und lassen dir anschließend eine Auftragsbestätigung sowie eine Rechnung zukommen.</li>
                                <li> Mit der Auftragsbestätigung beginnt dein GapYear. Lehn dich zurück - wir informieren dich über die nächsten Schritte.</li>
                              </ul>
                            </div>
                        </div>
                      </div>

                    </div>

                    </div>
                  </form>
                </ValidationObserver>




              </div>




            </div>

          </div>
        </div>

      </div>



    </div>
  </div>
</template>



<script>
    import Vue from "vue";
    import axios from 'axios';
    import VueAxios from 'vue-axios';
    import { uuid } from 'vue-uuid';
    import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
    import { email, required, alpha_spaces, regex, image } from 'vee-validate/dist/rules';
    import Multiselect from 'vue-multiselect';
    import vue2Dropzone from 'vue2-dropzone';
    import notice from './components/note';
    import VueMeta from 'vue-meta';

    Vue.use(VueAxios, axios);
    Vue.use(VueMeta);


    //Get Variable auslesen aus der URL
    const params = new URLSearchParams(window.location.search);
    Vue.prototype.$getGapProg  = params.get('prog');
    Vue.prototype.$setProg =  params.get('set'); //Zum einlesen von bestehenden Daten.



    extend('required', {
        ...required,
        message: 'Dieses Feld ist ein Pflichtfeld.'
    });

    extend('image', {
        ...image,
        message: 'Bitte dieses Feld ausfüllen.'
    });

    extend('email', {
        ...email,
        message: 'Bitte gebe deine E-Mailadresse ein.'
    });

    extend('alpha_spaces', {
        ...alpha_spaces,
        message: 'Es sind nur Buchstaben und Leerzeichen erlaubt.'
    });

    extend('regex', {
        ...regex,
        message: 'Bitte einen Gültiges Datum eingeben.'
    });




    export default {
        name: 'App',
        template: '<div>Test</div>',
        metaInfo: {
            title: 'GapYear Praxis - Registrierung',
            meta: [
                { charset: 'utf-8'},
                { name: 'viewport', content: 'width=device-width, initial-scale=1' }
                ]
        },
        components:{
            ValidationProvider,
            ValidationObserver,
            Multiselect,
            vue2Dropzone,
            notice,
        },
        computed:{
            activeProgramm: function () {
                return this.programms.filter(function (prog) {
                    return prog.active === true
                })[0]
            },
            activeStep: function () {
                return this.steps.filter(function (step) {
                    return step.active === true
                })[0]
            }
        },
        data: () => ({
            showPackages: false,
            filesUrl: '/storage/gapform/', //@todo Speicherort wo die Files abgelegt werden.
            texte: {
                currency: '€',
                tax: 'Alle Preise verstehen sich in Euro zzgl. der gesetzlichen MwSt.',
                infoDocuments: 'Diese Unterlagen benötigen wir für deine Aufnahme in den GapYear Praxis Pool. Unser Matching-Prozess beginnt mit dem Hochladen deiner vollständigen Unterlagen. Du bist im Matching Tool!',
                infoDiagnosis:{
                    diagnosis: "Diese wissenschaftlich fundierte Eignungsdiagnostik ermöglicht es uns, deine Stärken und Interessen besser zu berücksichtigen.",
                    showMe: false,
                },
            },
            uuid: uuid.v4(),
            userSet: false,
            resumeOptions: {
                method: 'post',
                headers: {
                    'Cache-Control': "",
                    'X-Requested-With': "",
                },
                renameFile: function (file) {
                        let newName = uuid.v4() + '.' + file.name.split('.').pop();
                        return newName;
                },
                url: '/gapform-files', //@todo temporäre Upload url setzen für den Lebenslauf
                thumbnailWidth: 200,
                maxFiles: 1,
                addRemoveLinks: true,
                dictRemoveFile: 'Löschen',
                dictCancelUpload: 'Abbrechen',
                dictCancelUploadConfirmation: 'Bist du dir sicher, das du den Upload abbrechen möchtest',
            },
            pictureOptions: {
                method: 'post',
                headers: {
                    'Cache-Control': "",
                    'X-Requested-With': "",
                },
                renameFile: function (file) {
                    let newName = uuid.v4() + '.' + file.name.split('.').pop();
                    return newName;
                },
                url: '/gapform-files', //@todo temporäre Upload url setzen für die Fotos
                thumbnailWidth: 200,
                maxFiles: 1,
                addRemoveLinks: true,
                dictRemoveFile: 'Löschen',
                dictCancelUpload: 'Abbrechen',
                dictCancelUploadConfirmation: 'Bist du dir sicher, das du den Upload abbrechen möchtest',
            },
            testimonyOptions: {
                method: 'post',
                headers: {
                    'Cache-Control': "",
                    'X-Requested-With': "",
                },
                renameFile: function (file) {
                    let newName = uuid.v4() + '.' + file.name.split('.').pop();
                    return newName;
                },
                url: '/gapform-files', //@todo temporäre Upload url setzen für die Zeugnisse
                thumbnailWidth: 200,
                maxFiles: 1,
                addRemoveLinks: true,
                dictRemoveFile: 'Löschen',
                dictCancelUpload: 'Abbrechen',
                dictCancelUploadConfirmation: 'Bist du dir sicher, das du den Upload abbrechen möchtest',
            },
            interest: [
                {name: 'Pädagogisch'},
                {name: 'Finance'},
                {name: 'verkäuferisch'},
                {name: 'künstlerisch'},
                {name: 'medizinisch-therapeutisch'},
                {name: 'naturwissenschaftlich'},
                {name: 'Umwelt'},
                {name: 'sozial'},
                {name: 'sprachlich/literarisch'},
                {name: 'technisch-datenanalysierend'},
                {name: 'technisch-handwerklich'},
                {name: 'technisch-mechanisch'},
                {name: 'unternehmerisch-planend'},
                {name: 'verkäuferisch-unterstützend'},
                {name: 'Politik'},
                {name: 'Architektur/Immobilien'},
                {name: 'IT/Informatik'},
                {name: 'Agrarwirtschaft'},
                {name: 'Musik'},
                {name: 'Medien/Kommunikation'},
                {name: 'Recht'},
                {name: 'E-Commerce'},
                {name: '(Online-)Marketing'},
                {name: 'Sonstiges' },

            ],
            diagnosis: [
                {
                    value: 'yes',
                    name: 'diagnosis',
                    id: 'diaYes',
                    label: 'Ja'
                },
                {
                    value: 'no',
                    name: 'diagnosis',
                    id: 'diaNo',
                    label: 'Nein'
                }
            ],
            communication: [
                {
                    value: 'Whatsapp',
                    name: 'communication',
                    id: 'comWhatapp',
                    label: 'WhatsApp'
                },
                {
                    value: 'E-Mail',
                    name: 'communication',
                    id: 'comMail',
                    label: 'E-Mail'
                }
            ],
            regional:[
                {
                    value: 'regio',
                    name: 'regional',
                    id: 'diaRegio1',
                    label: 'Lieber in der Region',
                    set: ''
                },
                {
                    value: 'overregio',
                    name: 'regional',
                    id: 'diaRegio2',
                    label: 'Überregional',
                    set: ''
                },
                {
                    value: 'foreigncountries',
                    name: 'regional',
                    id: 'diaRegio3',
                    label: 'Gerne im Ausland',
                    set: ''
                }
            ],
            formLabels:{
                firstname: 'Vorname',
                lastname: 'Nachname',
                phone: 'Telefon',
                mail: 'E-Mail-Adresse',
                birthday: 'Geburtstag',
                communication: 'Wie sollen wir miteinander kommunizieren?',
                diagnosis: 'Eignungsdiagnostik',
                regional: 'Regionale Ausrichtung',
                interest: "Was interessiert dich? (falls vorhanden, Präferenzen angeben)",
                interest_text: "Weitere Interssen",
                documents: 'Lade Bitte noch folgende Unterlagen hoch',
            },
            errorServer: 0,
            formData:
                {
                    currentStep: 0,
                    mail: '',
                    gender: '',
                    firstname: '',
                    lastname: '',
                    phone: '',
                    birthday: '',
                    communication: '',
                    diagnosis: '',
                    regional: '',
                    interest: '',
                    interest_text: '',
                    countinterest: 0,
                    resume_name: '',
                    resume_size: '',
                    resume_type: '',
                    picture_name: '',
                    picture_size: '',
                    picture_type: '',
                    testimony_name: '',
                    testimony_size: '',
                    testimony_type: '',
                    price: '',
                    monthlyprice: '',
                    agb: false,

                },
            programms: [
                {
                    id: '1',
                    active: false,
                    name: 'Unser Pool',
                    month: '6-Monate-Paket',
                    description: '',
                    info: 'Bei der nachfolgenden Registrierung wählst du das für dich passende GapYear Praxis Paket. Ergänze deine Angaben.',
                    showMe: false,
                    price: 99,
                    options: [
                        {
                            id: 0,
                            inputname: 'diagnosis',
                            name: 'Eignungsdiagnostik inklusive',
                            price: 0,
                            checked: true,
                        },
                        {
                            id: 1,
                            inputname: 'renewal',
                            name: '6 Monate Verlängerung',
                            price: 49,
                            checked: false,
                        },
                        {
                            id: 2,
                            inputname: 'monthly',
                            name: 'Zahlungsweise: monatliche Ratenzahlung aktivieren',
                            price: 0,
                            checked: true,
                        }
                    ],
                    usps: [
                        "Intelligentes Matching",
                        "Du erhältst für dich passende Praktikumsvorschläge (freie Wahl)",
                        "Eignungsdiagnostik inklusive",
                    ]
                },
                {
                    id: '2',
                    active: true,
                    name: 'Mein GapYear',
                    month: '6-Monate-Paket',
                    description: '',
                    info: 'Bei der nachfolgenden Registrierung wählst du das für dich passende GapYear Praxis Paket. Ergänze deine Angaben.',
                    showMe: false,
                    price: 550,
                    options: [
                        {
                            id: 0,
                            inputname: 'diagnosis',
                            name: 'Eignungsdiagnostik inklusive',
                            price: 0,
                            checked: true,
                        },
                        {
                            id: 1,
                            inputname: 'renewal',
                            name: '6 Monate Verlängerung',
                            price: 224,
                            checked: true,
                        },
                        {
                            id: 2,
                            inputname: 'monthly',
                            name: 'Zahlungsweise: monatliche Ratenzahlung aktivieren',
                            price: 0,
                            checked: true,
                        }
                    ],
                    usps: [
                        "Individuelle und vorausschauende Planung und Organisation",
                        "Persönlicher Ansprechpartner",
                        "Eignungsdiagnostik inklusive"
                    ]
                }
            ],
            steps: [
                {
                    id: 0,
                    active: false,
                    finish: true,
                    name: 'Dein Programm'
                },
                {
                    id: 1,
                    active: true,
                    finish: false,
                    name: 'Deine Daten'
                },
                {
                    id: 2,
                    active: false,
                    finish: false,
                    name: 'Deine Einstellungen'
                },
                {
                    id: 3,
                    active: false,
                    finish: false,
                    name: 'Deine Unterlagen'
                },
                {
                    id: 4,
                    active: false,
                    finish: false,
                    name: 'Kostenübersicht'
                },
                {
                    id: 5,
                    active: false,
                    finish: false,
                    name: 'Bestätigung'
                }
            ],
        }),
        mounted: function() {
            localStorage.apiversion = 1;

            if (!this.userSet && localStorage.activeProgramm) {

                this.programms.forEach(function(item){
                    if(localStorage.activeProgramm == item.id){
                        item.active = true;
                        this.progactive = item.name;
                    }else{
                        item.active = false;
                    }
                }.bind(this));
            }

            if(!this.userSet && this.$getGapProg){

                let check = false;

                this.programms.forEach(function(item){
                    if(this.$getGapProg == item.id){
                        item.active = true;
                        check = true;
                        this.progactive = item.name;
                    }else{
                        item.active = false;
                    }
                }.bind(this));

                //Wenn die Get Variable gesetzt ist, aber keine Üebreinstimmung gefunden wurde, so wird es auf das erste Element von Programms gesetzt.
                if(!check){
                    this.programms[0].active = true;
                }
            }

            /* Prüfen ob schon Formulardaten gespeichert wurden */
            if (localStorage.getItem('formData')) {
                let formData = JSON.parse(localStorage.getItem('formData'));
                this.formData = formData;
                this.setStep();
            }
            /* EOF Auslesen der Formuarldaten */

            /* Prüfen ob schon Formulardaten gespeichert wurden */
            if (localStorage.getItem('regional')) {
                let regional = JSON.parse(localStorage.getItem('regional'));
                this.regional = regional;
            }
            /* EOF Auslesen der Formuarldaten */


            /* Prüfen ob schon Daten für das Programm vorliegen */
            if (localStorage.getItem('programmOptions')) {
                let programmOptions = JSON.parse(localStorage.getItem('programmOptions'));

                //Setzen der bereits gesetzen optionen für das aktive Programm
                this.activeProgramm.options.forEach(function(item){
                    if(programmOptions[item.id].checked){
                        item.checked = true;
                    }
                });
            }
            /* EOF Auslesen der Formuarldaten */

            //Sollten Kommunikation noch nicht gesetzt sein, so wird diese Standardmäßig auf Whatsapp gesetzt.
            if(!this.formData.communication){
                this.formData.communication = "Whatsapp";
            }
            //Sollte die Dianostik noch nicht gesetzt sein, so wird diese Standardmäßig auf Ja gesetzt.
            if(!this.formData.diagnosis){
                this.formData.diagnosis = "yes";
            }

            this.loadfiles();
            this.changePrice();
            this.changeMonthlyPrice();


            if(this.$setProg){
                this.setFormData(this.$setProg); //@todo dies Eindukentieren wenn die Daten eingelesen werden.
            }

        },
        watch:{

           'formData.diagnosis':{
               deep: true,
               handler:function(val){

                //bind formData.diagnosis to the first option in the programm

                this.programms.forEach(elm => {
                   elm.options[0].checked = val == "yes";
                });
           }}
        },
        methods: {
            changeRegio: function(){

                let regions = [];

                this.regional.forEach(function(item){
                    if(item.set){
                        regions.push(item.label)
                    }
                });
                this.formData.regional = regions;

            },
            onChange (value) {
                this.formData.interest = value;
            },
            clearAll: function(){
                this.formData.interest = '';
            },
            afterResumeRemove(file){
                if(file.upload){
                    if(this.formData.resume_name === file.upload.filename && file.status != 'error'){
                        this.formData.resume_name = "";
                        this.formData.resume_size = "";
                        this.formData.resume_type = "";
                        this.saveStorage();
                    }
                }else if(this.formData.resume_name === file.name && file.status != 'error'){
                    this.formData.resume_name = "";
                    this.formData.resume_size = "";
                    this.formData.resume_type = "";
                    this.saveStorage();
                }
            },
            afterResumeComplete(file) {
                  if(file.upload && file.size && file.status != 'error'){
                      this.formData.resume_name = file.upload.filename;
                      this.formData.resume_size = file.size;
                      this.formData.resume_type = file.type;
                      this.saveStorage();
                  }
            },
            afterPictureRemove(file){
                if(file.upload){
                    if(this.formData.picture_name === file.upload.filename && file.status != 'error'){
                        this.formData.picture_name = "";
                        this.formData.picture_size = "";
                        this.formData.picture_type = "";
                        this.saveStorage();
                    }
                }else if(this.formData.picture_name === file.name && file.status != 'error'){
                    this.formData.picture_name = "";
                    this.formData.picture_size = "";
                    this.formData.picture_type = "";
                    this.saveStorage();
                }

            },
            afterPictureComplete(file) {
                if(file.upload && file.size && file.status != 'error'){
                    this.formData.picture_name = file.upload.filename;
                    this.formData.picture_size = file.size;
                    this.formData.picture_type = file.type;
                    this.saveStorage();
                }
            },
            afterTestimonyRemove(file){
                if(file.upload){
                    if(this.formData.testimony_name === file.upload.filename && file.status != 'error'){
                        this.formData.testimony_name = "";
                        this.formData.testimony_size = "";
                        this.formData.testimony_type = "";
                        this.saveStorage();
                    }
                }else if(this.formData.testimony_name === file.name && file.status != 'error'){
                    this.formData.testimony_name = "";
                    this.formData.testimony_size = "";
                    this.formData.testimony_type = "";
                    this.saveStorage();
                }
            },
            afterTestimonyComplete(file) {
                if(file.upload && file.size && file.status != 'error'){
                    this.formData.testimony_name = file.upload.filename;
                    this.formData.testimony_size = file.size;
                    this.formData.testimony_type = file.type;
                    this.saveStorage();
                }

            },
            loadfiles: function(){
                setTimeout(() => {
                    if(this.$refs.resume && this.formData.resume_name){
                        var fileResume = { size: this.formData.resume_size, name: this.formData.resume_name, type: this.formData.resume_type };
                        var urlResume = this.filesUrl + this.formData.resume_file;
                        this.$refs.resume.manuallyAddFile(fileResume, urlResume);
                    }

                    if(this.$refs.picture && this.formData.picture_name){
                        var filePicture = { size: this.formData.picture_size, name: this.formData.picture_name, type: this.formData.picture_type };
                        var urlPicture = this.filesUrl + this.formData.picture_file;
                        this.$refs.picture.manuallyAddFile(filePicture, urlPicture);
                    }

                    if(this.$refs.testimony && this.formData.testimony_name){
                        var fileTestimony = { size: this.formData.testimony_size, name: this.formData.testimony_name, type: this.formData.testimony_type };
                        var urlTestimony = this.filesUrl +  this.formData.testimony_file;
                        this.$refs.testimony.manuallyAddFile(fileTestimony, urlTestimony);
                    }
                }, 0);

            },
            toggleActive: function(){
                this.toggleClass
            },
            onSubmit () { //Formular absenden und einen Schritt vorwärts
                if (this.formData.currentStep === 4) {
                    this.submitForm();

                    //this.emptyData();
                    return;

                }

                this.formData.currentStep++;


                this.loadfiles();

                this.saveStorage();
                this.setStep();
            },
            /*onRetour: function() { //Einen Schritt Zurück beim Formular

                if(this.formData.currentStep > 1){
                    this.formData.currentStep--;
                }

                this.saveStorage();
                this.setStep();
            },*/
            saveStorage: function(){ //Daten In den Browsercache setzen
                const parsed = JSON.stringify(this.formData);
                localStorage.setItem('formData', parsed);

                const programmOptions = JSON.stringify(this.activeProgramm.options);
                localStorage.setItem('programmOptions', programmOptions);

                const regional = JSON.stringify(this.regional);
                localStorage.setItem('regional', regional);

            },
            goToStep: function(step){
                event.preventDefault();
                this.formData.currentStep = step;
              this.setStep();

              if(step == 3){
                  this.loadfiles();
              }

              this.saveStorage();

            },
            setStep: function(){ // Setzen des aktuellen Steps

                this.steps.forEach(function(step){
                    if(this.formData.currentStep == step.id) {
                        step.active = true;
                        step.finish = false;
                    }else if(this.formData.currentStep > step.id){
                        step.finish = true;
                        step.active = false;
                    }else{
                        step.active = false;
                    }
                }.bind(this));
            },
            openPackages: function(){
                this.showPackages = !this.showPackages //Status Switch für das auf und zuklappen der Pakete
            },
            selectPackage: function(GapPackage){
                localStorage.activeProgramm = GapPackage;
                this.programms.forEach(function(item){
                    if(GapPackage == item.id){
                        item.active = true;
                    }else{
                        item.active = false;
                    }
                }.bind(this));
                this.changePrice();
                this.changeMonthlyPrice();
                  this.formData.currentStep++;

            },
            changePackages: function(GapPackage){
                localStorage.activeProgramm = GapPackage;
                this.programms.forEach(function(item){
                    if(GapPackage == item.id){
                        item.active = true;
                    }else{
                        item.active = false;
                    }
                }.bind(this));
                this.changePrice();
                this.changeMonthlyPrice();
                this.openPackages();
            },
            changePrice: function(){
                let price =  this.activeProgramm.price;
                this.activeProgramm.options.forEach(function(item){
                    if(item.checked){

                        price = price + item.price;
                    }
                });
                this.formData.price = price;
            },
            changeMonthlyPrice: function(){
                let monthlyprice =  this.activeProgramm.price;
                let months = 6;
                this.activeProgramm.options.forEach(function(item){
                  if(item.checked){
                    if(item.inputname === 'renewal'){
                      months = 12;
                    }
                    monthlyprice = monthlyprice + item.price;
                  }
                });
                this.formData.monthlyprice = (monthlyprice / months).toFixed(2);
            },
            changeProgrammOptions: function(e){
                this.activeProgramm.options.forEach(function(item){
                    if(item.id == e.target.value){
                        if(e.target.checked){
                            item.checked = true;
                        }else{
                            item.checked = false;
                        }
                        return true;
                    }
                });
                this.changePrice();
                this.changeMonthlyPrice();
            },
            emptyData: function () {
                localStorage.clear();
            },
            submitForm() {
                axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    url: '/gapform-endpoint', //Endpoint einsetzen wo die Daten hin gesendet werden sollen.
                    data: {
                        formData: this.formData,
                        programm: this.activeProgramm,
                    }
                })
                    .then(function () {
                        this.errorServer = 0;
                        this.formData.currentStep++;
                        this.setStep();
                        this.saveStorage();
                    }.bind(this))
                    .catch(function () {
                        this.errorServer = 1
                        this.formData.currentStep = 4
                    }.bind(this));

            },
            setFormData(getDatas){

                let url = 'http://localhost:8081/gapform-php/gapform-get.php?data=' + getDatas;

                axios
                    .get(url) // @todo URL setzen woher bereits bestehende Daten abgerufen werden können... hier kann auch ein Parameter mit gegeben werden. Was dann durch das Skript verarbeitet wird und die passenden Daten ausliefert.
                    .then(function (response) {
                        this.formData = response.data[0]['formData'];

                        //console.log(response.data[0]['formData'].interest);

                        //Step auf aktive Setzen
                        this.steps.forEach(function(step){
                            if(this.formData.currentStep == step.id) {
                                step.active = true;
                                step.finish = false;
                            }else if(this.formData.currentStep > step.id){
                                step.finish = true;
                                step.active = false;
                            }else{
                                step.active = false;
                            }
                        }.bind(this));



                        //Setzen der Informationen zum Program
                        this.programms.forEach(function(item){

                            if(response.data[0]['program'].id == item.id){
                                item.active = true;

                                //Prüfen welche Optionen gesetzt sind.
                                item.options.forEach(function (option) {
                                    response.data[0]['program'].options.forEach(function (progOption) {
                                        if(progOption.id == option.id){
                                            option.checked = progOption.checked;
                                        }
                                    });
                                });

                            }else{
                                item.active = false;
                            }
                        });

                        this.saveStorage();

                        window.history.replaceState({}, document.title, "/"); //@todo hier noch die URL vom Formular eintragen ohne Parameter, damit beim Refresh nicht wieder die Daten geladen werden.

                    }.bind(this))
            }
        }
    }
</script>


<style lang="scss">

  @import '~vue2-dropzone/dist/vue2Dropzone.min.css';
  @import "~vue-multiselect/dist/vue-multiselect.min.css";
  @import "~bootstrap/scss/bootstrap";
  @import "./scss/style";

</style>
